import {Component} from '@angular/core';
import {ActivatedRoute, Router} from "@angular/router";
import * as qs from 'qs';
import {TranslateService} from "app/translate/translate.service";
import {FilterFormService} from "app/views/filter_form/filter_form.service";
import {HttpClient} from "@angular/common/http";
import {HelperService} from "app/lib/helper.service";
import {DomainBillingStats} from "app/models/domain_billing.model";
import {FilterParams} from "app/models/filter_form.model";
import {ChartParams} from "app/views/chart/chart.component";
import {ModalService} from "app/views/modal/base_modal.component";
import {BaseComponent} from "app/views/base.component";
import {EventsService} from "app/lib/EventsService";
import {AttachDomainDetailsComponent} from "./details/attach_domain_details/attach_domain_details.component";
import {SaveContactDetailsComponent} from "./details/save_contact_details/save_contact_details.component";
import {DetailsComponent} from "./details/details/details.component";


import dictionary from "dict/static.json";
import { DomainsService } from "../domains.service";

@Component({
	selector: 'domain-actions',
	templateUrl: './domain_actions.component.html'
})
export class DomainActionsComponent extends BaseComponent {
	stats: DomainBillingStats[];

	paginationLoader: boolean = false;
	statsLoader: boolean = true;

	chartData = new ChartParams();

	public dontLoad: any = {};

	domainParamsMap = {
		'searchedCount': 'searchDomain',
		'searchedUniqCount': 'searchUniqDomain',
		'selectedCount': 'selectedDomain',
		'paidCount': 'paidDomain',
		'saveContactCount': 'saveContactDomain',
		'attachCount': 'attachDomain'
	};

	public currencyList;

	addFilterParams = {
		userType: 'user',
		isDomainBilling: true,
		dateFilters: ['dateCreated', 'dateDomainAction', 'dateSiteCreated'],
		dateType: 'datePaid'
	};

	constructor(
		public eventsService: EventsService,
		public activatedRoute: ActivatedRoute,
		public translate: TranslateService,
		public router: Router,
		public filter: FilterFormService,
		private http: HttpClient,
		private helper: HelperService,
		private modalService: ModalService,
		public domainsService: DomainsService,
	) {
		super(eventsService, domainsService, activatedRoute, filter, translate);

		this.chartData.setOptions({
			names: {
				'searchedCount': this.translate.__A('billing.domain_billing.searchedCount'),
				'searchedUniqCount': this.translate.__A('billing.domain_billing.searchedUniqCount'),
				'selectedCount': this.translate.__A('billing.domain_billing.selectedCount'),
				'saveContactCount': this.translate.__A('billing.domain_billing.saveContactCount'),
				'attachCount': this.translate.__A('billing.domain_billing.attachCount'),
				'paidCount': this.translate.__A('billing.domain_billing.paidCount'),
				"prolongationCount": this.translate.__A('billing.domain_billing.prolongationCount.title')
			}
		});
	}


	async ngOnInit() {
		super.ngOnInit();

		this.currencyList = dictionary.currencyList;
	}


	async getData() {
		await this.getChart();
		await this.getStats();
	}


	// Получить данные для графика
	async getChart(params?: FilterParams) {
		if (this.dontLoad.chart) return true;

		this.chartData.showLoader();
		
		const { charts } = await this.domainsService.actions.chart(
			this.filter.getCopyFilterParams(params)
		).toPromise();
		this.chartData.data = charts;
		
		this.chartData.hideLoader();
	}


	// Получить данные для пагинации
	async getStats() {
		const me = this;

		me.statsLoader = true;

		if (me.dontLoad.pagination) {
			await me.getTable();
			me.statsLoader = false;
			return true;
		}

		if (me.filter.filterParams.period !== 'summary') {
			const pagination = await me.domainsService.actions.pagination(
				this.filter.filterParams
			).toPromise();
			me.pagination.fill(pagination);

			if (pagination) {
				me.updateLinks(
					me.domainsService.actions.getRealFullRoute()
				);
			}
		}
		await me.getTable();

		this.statsLoader = false;
	}


	// Получить данные для stats
	async getTable() {
        const me = this;

		const { stats } = await me.domainsService.actions.stats(
			me.filter.getCopyFilterParams({
				paginationDate: me.pagination.getDate()
			})
		).toPromise();
		me.stats = stats;

		for (let stat of this.stats) {
			const dates = me.helper.getTimeAsIntervals({
				timestamp: stat.timestamp,
				period: me.filter.filterParams.period
			});

			if (dates.length == 2) {
				stat.currentPeriod = dates[0] + '-' + dates[1];
			} else {
				stat.currentPeriod = dates[0];
			}

			stat.day = new Date(stat.timestamp).getDay();

			if (stat.currentPeriod == '') {
				stat.currentPeriod = 'summary';
			}
		}

		me.dontLoad = {};
	}


	// Клик по пагинации
	async onPageChange() {
		this.filter.filterParams.page = this.pagination.page;

		this.filter.filterParams.dateFilterParams = this.filter.getDateFilterParams(this.filter.filterParams, this.filter.addFilterParams);

		let params = this.filter.getApplyFilters(this.filter.filterParams),
			url = this.router.url.split('?')[0];

		params = qs.stringify(params, {encode: false});
		this.router.navigateByUrl(`${url}?${params}`, {relativeTo: this.activatedRoute});

		this.dontLoad = {
			chart: true,
			pagination: true
		};
	}


	async showDetails(key: string, stat: any) {
		let domainStatType = {
			'searchedCount': 'searchDomain',
			'searchedUniqCount': 'searchUniqDomain',
			'selectedCount': 'selectedDomain',
			'saveContactCount': 'saveContactDomain'
		}[key];
		
		let details;
		let component;
		if (key === 'attachCount') {
			details = stat.attachList;
			component = AttachDomainDetailsComponent;
		} else {
			if (key === 'searchedCount' || key === 'searchedUniqCount' || key === 'selectedCount') {
				component = DetailsComponent;
			} else if (key === 'saveContactCount') {
				component = SaveContactDetailsComponent;
			} else {
				throw new Error(`Domain Action.showDetails: key "${key}" in unknown!`);
			}
			
			const { stats } = await this.domainsService.actions.detail(
				this.filter.getCopyFilterParams(<FilterParams>{
					groupDate: stat.groupDate,
					domainStatType,
				})
			).toPromise();
			
			details = stats;
		}

		this.modalService.open(component, {
			title: this.translate.__A('billing.domain_billing.' + key + '.title') + ': ' + stat.currentPeriod,
			details,
		}, {size: 'hg'});
	}


	async updateData(filter) {
		await this.getChart(filter);
	}
}
